/* eslint-disable global-require, new-cap */
import Mediator from '@/scripts/stage/globals/mediator';


class States {
  start() {
    this.start3DWorld();
  }

  start3DWorld() {
    let w3 = require('./world3D.js');

    if (w3.default) {
      w3 = w3.default;
    }

    this.world3D = new w3();

    Mediator.resize();
  }
}

export default new States();
